module.exports = __webpack_public_path__ + "static/img/bg-sai-mine.e599a04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-sai-mine.png
// module id = 816
// module chunks = 0